import { useMemo } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { formatContactDisplay } from './contact-display';
import { ContactEditorApiService } from '~/services';

// Module-level so the store identity below is stable for the life of the module (WK-526): a new
// store identity on every render makes DevExtreme re-initialise the SelectBox mid-fetch.
const contactEditorApiService = new ContactEditorApiService();

/**
 * Picks an existing contact from every contact in the system, sorted, searchable, and labelled with
 * the companies the contact is currently at so two people of the same name can be told apart
 * (WK-565 — this list used to be unsorted and name-only).
 *
 * Owns its own data source, per the editors-own-their-lookups convention: callers pass context, not
 * stores. Creating a contact is a separate flow reached from the drop-down above the grid, so this
 * deliberately does one thing.
 *
 * @param {number} [value] - currently selected contact id
 * @param {Function} [onSelectionChanged] - ({ selectedItem }) => void
 */
export function ContactPicker({
  value,
  onSelectionChanged,
  placeholder = 'Select a contact...',
}) {
  const dataSource = useMemo(() => contactEditorApiService.getAllContactsDataSource(), []);

  return (
    <SelectBox
      dataSource={dataSource}
      // A function displayExpr can't be turned into a server-side filter, so searching is pointed
      // at the scalar the API does sort and filter on.
      displayExpr={formatContactDisplay}
      searchExpr="fullName"
      valueExpr="contactId"
      value={value}
      searchEnabled={true}
      placeholder={placeholder}
      onSelectionChanged={(e) => onSelectionChanged?.(e)}
    />
  );
}
